import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const timeLeft = (until) => {
  const ms = new Date(until) - Date.now();
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
  return `${h}h ${String(m).padStart(2, "0")}m`;
};

export const PreviewNudge = ({ until }) => {
  useEffect(() => {
    if (!until || sessionStorage.getItem("xq_preview_nudged")) return;
    const ms = new Date(until) - Date.now();
    if (ms <= 0 || ms > 2 * 3600000) return;
    sessionStorage.setItem("xq_preview_nudged", "1");
    toast("Your Team preview ends in " + (timeLeft(until) || "moments"), { description: "Upgrade to keep Sharpe, Calmar, institutional metrics and metrics without the 2-hour delay.", action: { label: "Upgrade", onClick: () => { window.location.href = "/billing"; } }, duration: 15000 });
    api.post("/demo/preview-nudge").catch(() => {});
  }, [until]);
  return null;
};

export const PreviewBanner = ({ until }) => {
  const [left, setLeft] = useState(() => (until ? timeLeft(until) : null));
  useEffect(() => { if (!until) return; const t = setInterval(() => setLeft(timeLeft(until)), 30000); return () => clearInterval(t); }, [until]);
  if (!until || !left) return null;
  return (
    <div className="preview-banner" data-testid="pro-preview-banner">
      <span><Crown size={14} /> <b>Team preview</b> · every metric unlocked, no 2-hour delay · <span className="mono" data-testid="pro-preview-left">{left}</span> left</span>
      <Link to="/billing" className="btn sm" data-testid="pro-preview-upgrade-btn">Upgrade to keep it</Link>
    </div>
  );
};
